import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_BASE_URL;

// Initial state
const initialState = {
  preview: null,      // For previewed import
  imported: null,     // For successfully imported employees
  loading: 'idle',    // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

// Async thunk for uploading/importing employees
export const importEmployees = createAsyncThunk(
  'employeeImport/importEmployees',
  async ({ file, companyId, preview }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      if (companyId) formData.append('companyId', companyId);
      if (preview) formData.append('preview', 'true');

      const response = await axios.post(
        `${API_URL}/employee/import`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );

      return response.data;
    } catch (err) {
      // Extract detailed error if available
      return rejectWithValue(err.response?.data || err.message || 'Failed to import employees');
    }
  }
);

// Slice
const employeeImportSlice = createSlice({
  name: 'employeeImport',
  initialState,
  reducers: {
    clearImportState: (state) => {
      state.preview = null;
      state.imported = null;
      state.loading = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Pending
      .addCase(importEmployees.pending, (state) => {
        state.loading = 'loading';
        state.error = null;
        state.preview = null;
        state.imported = null;
      })
      // Fulfilled
      .addCase(importEmployees.fulfilled, (state, action) => {
        state.loading = 'succeeded';
        if (action.payload.preview) {
          state.preview = action.payload.preview;
        } else {
          state.imported = action.payload.employees || [];
        }
      })
      // Rejected
      .addCase(importEmployees.rejected, (state, action) => {
        state.loading = 'failed';
        state.error = action.payload || 'Failed to import employees';
      });
  },
});

export const { clearImportState } = employeeImportSlice.actions;
export default employeeImportSlice.reducer;
